import React from 'react';
import { useTranslation } from 'react-i18next';

import dayjs from 'shared/helpers/dayjs';
import { InsightsEvent } from 'dashboard/types';
import { getUrgencyColors, getUrgencyLabel } from 'dashboard/urgencyColors';
import { EntityTag } from 'shiftNotes/components/EntityTag/_index';

import * as Styled from 'dashboard/styles/Events.style';
import * as Text from 'theme/components/Text.style';

interface EventCardProps {
  event: InsightsEvent;
  onSelect: (eventId: string) => void;
}

export default function EventCard({
  event,
  onSelect,
}: EventCardProps): JSX.Element {
  const { t } = useTranslation('pageDashboard');

  const formattedDate = dayjs(event.created).format('MMM D');
  const urgencyColors = getUrgencyColors(event.urgency_key);
  const urgencyLabel = getUrgencyLabel(event.urgency_key, t);

  const handleClick = () => {
    onSelect(event.id);
  };

  return (
    <Styled.EventCard onClick={handleClick}>
      <Styled.EventCardContent>
        <Styled.MetaRow>
          <Text.Label>{formattedDate}</Text.Label>
          <Styled.MetaDot />
          <Text.Label>
            {t('events.notes', { count: event.shift_notes_count })}
          </Text.Label>
        </Styled.MetaRow>
        <Styled.EventTitle>{event.title}</Styled.EventTitle>
      </Styled.EventCardContent>

      {urgencyColors && urgencyLabel && (
        <EntityTag
          extractionClass="urgency"
          category={urgencyLabel}
          description={event.category_description}
          colors={urgencyColors}
        />
      )}
    </Styled.EventCard>
  );
}
